import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["banner"]
  static values = { key: { type: String, default: "upgrade-banner-dismissed" } }

  connect() {
    if (sessionStorage.getItem(this.keyValue) === "true") {
      this.bannerTarget.classList.add("hidden")
    }
  }

  dismiss() {
    this.bannerTarget.classList.add("hidden")
    sessionStorage.setItem(this.keyValue, "true")
  }
}
